class CentimetersToInches {
  constructor() {
    this.centimetersToInches();
  }

  centimetersToInches() {
    let buttons = document.querySelectorAll('.measurement-button input');
    let measurements = document.querySelectorAll('.measurements .size-guide--grid-item');

    if (buttons && measurements) {
      buttons.forEach(el => {
        el.addEventListener('change', (event) => {
          measurements.forEach(element => {
            element.style.zIndex = 1;
            if (element.classList.contains(el.value)) {
              element.style.zIndex = 10;
            }
          });
          console.log(el);
        });
      });
    }
  }
}

export default CentimetersToInches;